import React from 'react';
import { Link } from 'react-router-dom';

const s = {
  wrap: { maxWidth: 800, margin: '0 auto', padding: '120px 24px 80px', color: '#101F33', fontFamily: "'IBM Plex Sans', sans-serif", lineHeight: 1.7 },
  back: { display: 'inline-block', padding: '10px 24px', background: '#E5A100', color: '#fff', borderRadius: 999, textDecoration: 'none', fontSize: '0.9rem', fontWeight: 600, marginBottom: 40 },
  h1: { fontSize: '2rem', fontWeight: 700, fontFamily: "'Inter Tight', sans-serif", textAlign: 'center', marginBottom: 48, letterSpacing: '-0.02em' },
  sec: { marginBottom: 32 },
  h2: { fontSize: '1.1rem', fontWeight: 600, marginBottom: 8, color: '#101F33' },
  p: { fontSize: '0.95rem', color: '#5d6978', marginBottom: 8 },
  it: { fontSize: '0.95rem', color: '#5d6978', marginBottom: 8, fontStyle: 'italic' },
  inner: { maxWidth: 640, margin: '0 auto' },
};

export default function PrivacyPolicy() {
  return (
    <div style={s.wrap}>
      <div style={{ textAlign: 'center' }}>
        <Link to="/" style={s.back}>← ホームページに戻る</Link>
      </div>

      <h1 style={s.h1}>プライバシーポリシー</h1>

      <div style={s.sec}>
        <h2 style={s.h2}>1．個人情報の適正な取扱い</h2>
        <p style={s.p}>
          当社は、AI を活用した医療・小売・その他 DX ソリューションを提供する企業として、個人情報の保護を経営上の最優先課題の一つと位置づけます。日本の「個人情報の保護に関する法律（APPI）」および関連する国内外の法令・ガイドライン（GDPR 等を含む）を遵守し、本ポリシーに基づき適正に取扱います。従業員・役員に対し継続的な教育と監査を実施し、組織的・人的・物理的・技術的管理体制を構築します。
        </p>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>2．取得する個人情報の範囲</h2>
        <p style={s.it}>取得は適法かつ公正な手段により行い、目的達成に必要な最小限に限定します。</p>
        <div style={s.inner}>
          <p style={{ ...s.p, fontWeight: 600 }}>事業領域／取得する主な情報</p>
          <p style={s.p}><strong>医療事業：</strong>医師・薬剤師等の氏名、勤務先、専門領域、学位・経歴、連絡先、契約・支払情報、紹介状・論文等の業績情報</p>
          <p style={s.p}><strong>小売事業：</strong>氏名、性別、生年月日、住所、電話番号、メールアドレス、クレジットカード番号、共通 ID、購買履歴、ポイント情報</p>
          <p style={s.p}><strong>その他事業（例：B2B SaaS、R&D プラットフォーム、採用活動 等）：</strong>法人担当者の氏名・連絡先、ログイン ID、利用ログ、契約・請求情報、応募者の経歴書・適性検査結果、当社への問い合わせ内容</p>
        </div>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>3．個人情報の利用目的</h2>
        <div style={s.inner}>
          <p style={s.p}><strong>医療事業：</strong>AI 分析結果・リアルワールドエビデンス等の情報提供、医療従事者向けサービスの契約管理、法令遵守報告</p>
          <p style={s.p}><strong>小売事業：</strong>製品の注文受付・発送・代金決済・アフターサービス、使用上のアドバイス、問い合わせ対応、リコール等の緊急連絡、DM・メールマガジン・キャンペーンのお知らせ、新商品・新サービス企画、顧客分析、満足度調査</p>
          <p style={s.p}><strong>その他事業：</strong>SaaS 利用者の認証、ログ解析による機能改善、共同研究・PoC プロジェクトの進行管理、成果報告、採用選考、入社手続、オンボーディング支援</p>
          <p style={s.it}>※上記各目的達成に必要な範囲での業務委託・第三者提供。契約終了後も法令で認められる範囲内で利用する場合があります。</p>
        </div>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>4．個人情報の安全管理</h2>
        <div style={s.inner}>
          <p style={s.p}>基本方針・規程：情報セキュリティポリシーおよび CSIRT 運用手順を策定</p>
          <p style={s.p}>技術的対策：暗号化、ゼロトラスト認証、アクセス権限の最小化</p>
          <p style={s.p}>人的対策：秘密保持契約、年 1 回以上の研修・試験</p>
          <p style={s.p}>物理的対策：入退室管理、サーバールーム多要素認証</p>
          <p style={s.p}>委託先管理：ISMS 等の認証有無を審査し、契約で義務付け</p>
          <p style={s.p}>漏えい等の事故対応：事実確認・影響評価（24 h 以内に暫定報告）、再発防止策・是正措置の策定、個人情報保護委員会および影響を受ける本人への速やかな通知、関係当局・業務委託先・取引先への連絡、ウェブサイト等での公表、FAQ 設置</p>
        </div>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>5．個人情報の第三者提供</h2>
        <p style={s.p}>
          法令で許容される場合または本人の同意がある場合を除き、第三者に提供しません。提供時は提供先での再提供禁止、機密保持、利用目的限定を契約で義務付けます。国外移転時は移転先の法制度を評価し、必要に応じて SCC（Standard Contractual Clauses）等を締結します。
        </p>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>6．個人情報取扱いの委託</h2>
        <p style={s.p}>
          クラウド事業者、配送会社、決済代行、マーケティング会社等に業務を委託する場合があります。委託先の選定基準、監査、定期的なセキュリティ評価を実施します。
        </p>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>7．開示・訂正・利用停止等の請求</h2>
        <p style={s.p}>
          本人または代理人確認後、合理的期間・範囲で対応します。請求手続および手数料の有無は当社ウェブサイトのお問い合わせ窓口に掲載します。
        </p>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>8．クッキー（Cookie）の使用</h2>
        <p style={s.p}>
          当社サイトでは Cookie・類似技術を使用し、閲覧履歴解析、広告配信、UX 改善を行います。ブラウザ設定で拒否可能ですが、一部機能が利用できない場合があります。第三者配信 Cookie の無効化は各事業者のオプトアウトページより行えます。
        </p>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>9．アクセスログの取得・利用</h2>
        <p style={s.p}>
          アクセス日時、IP アドレス、閲覧ページ、ブラウザ種別等を記録し、セキュリティ確保、パフォーマンス分析、サービス改善に使用します。個人を直接特定する目的では利用しません。
        </p>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>10．共同利用</h2>
        <div style={s.inner}>
          <p style={s.p}>共同利用する情報の範囲：氏名、連絡先、共通 ID、購買・利用履歴等</p>
          <p style={s.p}>共同利用者の範囲：当社グループ会社、業務提携先</p>
          <p style={s.p}>利用目的：前項「3．個人情報の利用目的」と同一</p>
          <p style={s.p}>管理責任者：株式会社 ReCoPilot（所在地：東京都新宿区北町 24-1、代表取締役 LI TIANQI）</p>
        </div>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>11．匿名加工情報・仮名加工情報</h2>
        <p style={s.p}>
          当社は研究開発やアルゴリズムの検証のために、法令に基づき安全性を確保した匿名加工情報・仮名加工情報を作成・利用する場合があります。第三者提供時には、再識別禁止など必要な安全管理措置を講じます。
        </p>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>12．プライバシーポリシーの改定</h2>
        <p style={s.p}>
          法令改正（例：2025 年予定の APPI 改正）や事業内容の変更等に応じ、予告なく改定することがあります。改定後はウェブサイトに掲載した時点で適用します。
        </p>
      </div>

      <div style={s.sec}>
        <h2 style={s.h2}>13．お問い合わせ窓口</h2>
        <p style={s.p}>
          個人情報保護管理責任者：コーポレートコンプライアンス部長<br />
          E-mail：privacy@recopilot.jp<br />
          受付時間：平日 10:00–17:00（年末年始・当社指定休日を除く）
        </p>
      </div>
    </div>
  );
}
